import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class ICompanyContacts {
  id: string;
  CType: 'EMAIL' | 'PHONE' | 'ADDRESS';
  creatorId: number;
  companyId: number;
  regionId: number;
  createdAt: string;
  updatedAt: string;
  name: string;
  cvalue: string;
}

export class ICompanyContactsResponse {
  @Type(() => ICompanyContacts)
  result: ICompanyContacts;
}

export class ICompanyContactsListResponse extends IPagination {
  @Type(() => ICompanyContacts)
  results: ICompanyContacts[];
}

export class ICompanyContactsQueryDto extends IQueryPaginationDto {
  companyId?: string;
}

export class ICompanyContactsPostDto {
  CType: 'EMAIL' | 'PHONE' | 'ADDRESS';
  creatorId: number;
  companyId: number;
  regionId: number;
  name: string;
  cvalue: string;
}
